<template>
  <v-main>
    <sidebar-comp></sidebar-comp>
    <v-container fluid>
      <slot />
    </v-container>
    <footer-comp></footer-comp>
  </v-main>
</template>
<script>
import {} from "pinia";
import FooterComp from "./FooterComp.vue";
import SidebarComp from "./SidebarComp.vue";
export default {
  components: {
    FooterComp,
    SidebarComp,
  },
  computed: {},
  async created() {},
  methods: {},
  data() {
    return {
      routeName: this.$route.name,
      user: {
        fullName: null,
      },
      menuItems: {
        menuItems: [],
      },
    };
  },
};
</script>
<style>
body {
  font-family: "Source Sans Pro", -apple-system, BlinkMacSystemFont, "Segoe UI",
    Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji",
    "Segoe UI Emoji", "Segoe UI Symbol";
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}
.v-main {
  background-color: #e9ecef;
  min-height: 100vh !important;
}
.v-container {
  min-height: 83vh;
}
</style>
